<div class="aqx-home-top"
     *ngIf="configuration.siteInfo.siteFeatures.showHomeImage">

  <img class="img-fluid"
       src="assets/images/Aqaix-Digitizing-Water-Finance.jpg">

  <div class="aqx-home-top-container">
    <div class="aqx-home-top-heading">
      Aqaix API Store
    </div>
    <div class="aqx-home-top-tagline">
      The Aqaix API Store enables easy, secure sharing of water data via APIs.
    </div>
  </div>
</div>

<div class="container-fluid mb-2"
       *ngIf="!configuration.siteInfo.siteFeatures.showHomeImage">

  <div class="row border-bottom px-1 pb-4">
    <div class="col-lg-12">
      <div class="aqx-home-top-heading-no-background-image aqx-color-primary">
        {{configuration.siteInfo.siteTitle}}
      </div>
      <div class="aqx-home-top-tagline-no-background-image">
        The API Store enables easy, secure sharing of water data via APIs.
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mb-2">
  <div class="row border-bottom p-2">
    <div class="col-lg-9">
      <div class="mx-auto">
        <div class="aqx-home-heading aqx-color-primary">
          Share and Distribute Data
        </div>
        <div>
          <div class="mt-3">
            An API ("Application Programming Interface") is like a software smart valve on data, allowing secure, controlled access to that data. APIs are the key to modern data
            integration, and to business process automation, and are at the heart of modern software platforms such as Google, Uber, Facebook, and many others.
          </div>
          <div class="mt-3">
            The modern standard for APIs is the architectural style of creating "RESTful APIs", or REST APIs ("Representational State Transfer").
            REST APIs allow one system to communicate its status to another.
            They also have a short learning curve, and a programmer familiar with REST can see a REST API set, and immediately know to use them to program to a system.
          </div>
          <div class="mt-3">
            Typical uses for REST APIs:
            <ul>
              <li>Making enterprise and legacy data accessible to mobile phones applications, for new User Experience (UX)</li>
              <li>"Mashups" of data from various sources</li>
              <li>Control over data subscriptions, and monetization of data</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3 my-auto text-center">
      <i class="fa fa-cogs fa-9x"></i>
    </div>
  </div>
  <div class="row border-bottom p-2">
    <div class="col-lg-3 my-auto text-center">
      <i class="fas fa-user-lock fa-9x"></i>
    </div>
    <div class="col-lg-9">
      <div class="mx-auto">
        <div class="aqx-home-heading aqx-color-primary">
          Safe, Easy, and Secure Access
        </div>
        <div>
          REST APIs work hand in hand with the OAuth 2.0 security system, to allow an additional security layer to be put in front of existing data security systems.
          OAuth2.0 offers a wide variety of security models and entitlements management, and ensures that a data owner has complete control over who has access to data,
          and when the data is accessed.
        </div>
      </div>
    </div>
  </div>
  <div class="row border-bottom p-2">
    <div class="col-lg-9">
      <div class="mx-auto">
        <div class="aqx-home-heading aqx-color-primary">
          Participate in the Digital Economy
        </div>
        <div>
          Our precarious water situation increasingly requires an integrated understanding of a water context, employing data from many dimensions. For example, basin balance
          models typically employ data for hydrology (runoff), groundwater, climatology, meteorology, quality, and other dimensions. Another use is for corporate water
          supply chain resiliency modeling, using similar data to model enterprise resiliency in the face of various water situations.
        </div>
        <div class="mt-3">
          "Data is the New Oil" is a frequent claim, and APIs are the means to implement value chains of data.
        </div>
      </div>
    </div>
    <div class="col-lg-3 my-auto text-center">
      <i class="fas fa-swimmer fa-9x"></i>
    </div>
  </div>
</div>
